module.exports = __webpack_public_path__ + "img/CM-MC-25-Toyota-Modern.11769869.jpg";